/* Sunday Dog advertorial: deep links, offer picker, sticky bar, reading progress, analytics.
   Every [data-pdp] link goes to the product page with the matching variant and the pack pre-selected:
     ../index.html?v=<variant>&pack=<n>   (kit: &pick=chews|drops)   + every utm_* / fbclid passed through.
   Variant: ?v= on this page (if allowed) -> utm_term group (a, c, e...) -> the page's default (body[data-default-v]).
   In Shopify the base becomes /products/<handle> and v is carried as utm_term (see NOTES.md). ?static=1 = screenshot mode. */
(function () {
  'use strict';
  var Q = new URLSearchParams(location.search), B = document.getElementById('sd-adv') || document.body, STATIC = Q.get('static') === '1';
  /* Shopify (theme v25): the wrapper carries data-pdp-url (/products/<handle>) and links use ?sd_lp=<page id> instead of ?v= */
  var PDP = B.getAttribute('data-pdp-url');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var allowed = (B.getAttribute('data-allowed') || '').split(','), kind = B.getAttribute('data-kind');
  var v = B.getAttribute('data-default-v');
  if (Q.get('v') && allowed.indexOf(Q.get('v')) > -1) v = Q.get('v');
  else if (!PDP && Q.get('utm_term')) { var g = Q.get('utm_term').toLowerCase().replace(/^r\d[_-]/, ''), cand = kind + '-' + g.toUpperCase(); if (allowed.indexOf(cand) > -1) v = cand; }

  function sel(name) { var r = $('input[name="' + name + '"]:checked'); return r ? r.value : null; }
  function href(a) {
    var p = new URLSearchParams(); p.set(PDP ? 'sd_lp' : 'v', v);
    var from = a.getAttribute('data-pdp-from');
    if (kind === 'kit') { p.set('pick', from === 'pick' ? (sel('pick') || 'chews') : 'chews'); p.set('color', sel('color') || 'blue'); }
    else {
      var pk = from === 'pack' ? sel('pack') : a.getAttribute('data-pdp-pack'); if (pk) p.set('pack', pk);
      /* the offer's packs are sized (Small/Medium/Large = 1/2/3 tubs): carry the size so the product page shows the same dose */
      var r = from === 'pack' ? $('input[name="pack"]:checked') : $('input[name="pack"][value="' + pk + '"]');
      if (r && r.getAttribute('data-size')) p.set('size', r.getAttribute('data-size'));
    }
    Q.forEach(function (val, key) { if (/^utm_|^fbclid$/.test(key)) p.set(key, val); });
    if (!p.get('utm_content')) p.set('utm_content', 'adv_' + kind + '_' + (a.getAttribute('data-cta') || 'link'));
    return (PDP || '../index.html') + '?' + p.toString();
  }
  function paintLinks() { $$('[data-pdp]').forEach(function (a) { a.setAttribute('href', href(a)); }); }
  $$('[data-pdp]').forEach(function (a) { a.addEventListener('click', function () { a.setAttribute('href', href(a)); track('advertorial_cta_click', { cta: a.getAttribute('data-cta'), section: lastSec }); }); });

  /* offer picker: keep the button label and price in step */
  function paintOffer() {
    var r = $('input[name="pack"]:checked') || $('input[name="pick"]:checked'); if (!r) return;
    var nm = $('[data-pack-name]'), pr = $('[data-pack-price]');
    if (r.name === 'pack') nm.textContent = r.value + (r.value === '1' ? ' tub' : ' tubs'); else nm.textContent = (r.value === 'drops' ? 'Drops' : 'Chews') + ' kit';
    pr.textContent = r.getAttribute('data-price');
    paintKitImg();
    paintLinks();
  }
  /* v26: the offer picture follows probiotic + bowl color once Codex's colored kit photos exist (else the gray one + a note) */
  function paintKitImg() {
    var ki = $('[data-kit-img]'); if (!ki) return;
    var pk = sel('pick') || 'chews', c = sel('color') || 'blue', col = ki.getAttribute('data-' + pk + '-' + c);
    ki.src = col || ki.getAttribute('data-' + pk);
    var no = $('[data-color-note]'); if (no) no.hidden = !!col;
  }
  /* v26: kit bowl color (Gray sold out, disabled); carried to the product page as &color= */
  $$('input[name="color"]').forEach(function (r) { r.addEventListener('change', function () {
    var n = $('[data-color-name]'); if (n) n.textContent = r.value.charAt(0).toUpperCase() + r.value.slice(1);
    paintKitImg(); paintLinks(); track('advertorial_color_pick', { value: r.value }); }); });
  $$('input[name="pack"], input[name="pick"]').forEach(function (r) { r.addEventListener('change', function () { paintOffer(); track('advertorial_pack_pick', { value: r.value }); }); });
  paintOffer(); paintLinks();

  /* delivery (Matt, Oct 12): "Arrives in 5–9 days", calendar days, never "business days" (cfg.SHIP) */
  $$('[data-ship-est]').forEach(function (s) { s.textContent = B.getAttribute('data-ship') || 'Arrives in 5–9 days.'; });

  /* reading progress + sticky bar (after 30%, hidden over the offer, dismissible) */
  var prog = $('[data-prog]'), stick = $('[data-stick]'), offer = $('#offer'), dismissed = false, offerOn = false, marks = {}, lastSec = 0;
  if (STATIC) { stick.remove(); document.documentElement.classList.add('is-static'); }
  $('[data-stick-x]') && $('[data-stick-x]').addEventListener('click', function () { dismissed = true; stick.classList.remove('is-on'); track('advertorial_sticky_dismiss', {}); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { offerOn = e.isIntersecting; onScroll(); }); }).observe(offer);
    var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) lastSec = +e.target.getAttribute('data-sec'); }); }, { rootMargin: '-40% 0px -50% 0px' });
    $$('[data-sec]').forEach(function (s) { sio.observe(s); });
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight, f = h > 0 ? scrollY / h : 0;
    if (prog) prog.style.transform = 'scaleX(' + f.toFixed(3) + ')';
    if (stick && stick.isConnected) { var on = !dismissed && f > .3 && !offerOn; stick.classList.toggle('is-on', on); stick.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    [25, 50, 75, 100].forEach(function (m) { if (f * 100 >= m - 1 && !marks[m]) { marks[m] = 1; track('advertorial_scroll_' + m, {}); } });
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  function track(name, props) {
    var L = (window.SundayDog && window.SundayDog.landing) || {};
    var p = { advertorial: kind, target_variant: v, sd_landing_variant: L.key || ('adv-' + kind), utm_term: Q.get('utm_term'), utm_content: Q.get('utm_content') }; for (var k in props) p[k] = props[k];
    if (window.posthog && posthog.capture) posthog.capture(name, p); else if (Q.get('debug') === '1') console.log('[track]', name, p);
  }
  track('advertorial_view', {});
})();
